import React from "react"

import * as st from './MaskedInput.styled.js'

const MaskedInput = ({
  className,
  id,
  type,
  size,
  mask,
  unmask,
  autoFocus,
  value,
  placeholder,
  isError,
  onChange,
}) => (
  <st.MaskedInput
    id={id}
    mask={mask}
    className={className}
    type={type}
    size={size}
    autoFocus={autoFocus} /* eslint-disable-line jsx-a11y/no-autofocus */
    value={value}
    unmask={unmask}
    isError={isError}
    placeholder={placeholder}
    onAccept={onChange}
  />
)

export default MaskedInput
